import Dispatcher from "events-dispatch";
import { triggerEvent } from "../../services/helpers/trigger-event";
import { mask } from "../../services/mask";

// обернуть, добавить маску
// вывести маску
// показать окно
// отследить закрытие (маска, крестик)
// событие закрытия
// метод открытия
// метод закрытия
// при открытии вызывать событие, по которому закроется все остальное

/**
 * @typedef { Object } ModalConfig
 * @description Объект конфигурации модального окна
 * @property { Function } canOpen
 * @property { Function } canClose
 */

/**
 * @typedef { Object } ModalNodes
 * @description Основные узлы модального окна
 * @property { HTMLElement } wrapper
 * @property { HTMLElement } element
 * @property { HTMLElement } mask
 * @property { HTMLElement[] } close
 */


const opened = [];

/**
 * @class Модальное окно
 * @property { Object } nodes
 * @property { HTMLElement } nodes.m
 */
class Modal {
    static get events() {
        return {
            opened: "modal.events.opened", // окно открыто
            closed: "modal.events.closed", // окно закрыто
            willOpen: "modal.events.willOpen", // окно будет открыто
            willClose: "modal.events.willClose", // окно будет закрыто
        }
    }

    static onOpen(modal) {
        opened.forEach(openedModal => {
            if (modal !== openedModal) openedModal.close();
        });
        opened.length = 0;
        opened.push(modal);
        mask.block();
    }

    static onClose(modal) {
        let index = opened.indexOf(modal);
        opened.splice(index, 1);
        if (!opened.length) mask.reset();
    }

    /**
     * @constructor
     * @param { HTMLElement } element 
     * @param { ModalConfig } config 
     */
    constructor(element, config) {
        new Dispatcher(this);

        this.config = config;
        this.nodes = this._initDOM(element);
        this._init();
        
    }

    /**
     * Инициализация DOM-элементов
     * @param { HTMLElement } element 
     * @returns { ModalNodes } 
     */
    _initDOM(element) {
        let wrapper = document.createElement('div');
        wrapper.classList.add('popup-container');

        let mask = document.createElement('div');
        mask.classList.add('popup-mask');
        
        wrapper.appendChild(mask);
        wrapper.appendChild(element);

        let close = element.querySelectorAll('[data-close]');

        element.style.visibility = "visible";
        element.style.opacity = "1";

        return {
            wrapper, element, mask, close
        };
    }

    /**
     * Прослушивание событий
     */
    _init() {
        this.nodes.mask.addEventListener('click', () => this.close());
        
        if (this.nodes.close.length) {
            this.nodes.close.forEach(el => {
                el.addEventListener('click', () => this.close());
            });
        }
    }

    /**
     * Открыть модальное окно
     */
    open() {
        if (typeof this.config.canOpen === "function") {
            if (!this.config.canOpen.call(this)) return;
        }

        Modal.onOpen(this);

        this.triggerEvent(Modal.events.willOpen);
        document.body.appendChild(this.nodes.wrapper);
        this.triggerEvent(Modal.events.opened);
    }

    /**
     * Закрыть модальное окно
     */
    close() {
        if (typeof this.config.canClose === "function") {
            if (!this.config.canClose.call(this)) return;
        }

        Modal.onClose(this);

        this.triggerEvent(Modal.events.willClose);
        this.nodes.wrapper.remove();
        this.triggerEvent(Modal.events.closed);
    }

    /**
     * Оповестить о наступлении события
     * @param { string } eventName 
     */
    triggerEvent(eventName) {
        triggerEvent(document.body, eventName);
        this.trigger(eventName);
    }
}

export default Modal;